module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_cuadrada_fondo_2.6857cc8e.jpg";